<div class="f-12 px-5 mt-3">
  <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>
  <div class="px-1">
    <div class="d-flex flex-row flex-wrap justify-content-end">
      @if (shouldShowContent) {
        @if (this.commonService.selectionDetails) {
          @for (item of this.commonService.selectionDetails; track item.label) {
            <div class="justify-content-around p-2">
              <div>
                <p-chip>
                  <span
                    class="fw-bold text-primary-contrast rounded-full flex items-center justify-center">
                    {{ item.label }}:
                  </span>
                  <span class="font-medium">
                    {{ item.text }}
                  </span>
                </p-chip>
              </div>
            </div>
          }
        }
      }
    </div>
  </div>
</div>
